export default __webpack_public_path__ + "static/media/gallery-icon.d23d9365.svg";